import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

type Toast = { id: number; message: string; variant: 'success' | 'error' | '' };

type ToastApi = { showToast: (message: string, variant?: 'success' | 'error' | '') => void };

const Ctx = createContext<ToastApi | null>(null);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = useCallback((message: string, variant: 'success' | 'error' | '' = '') => {
    const id = Date.now();
    setToasts((t) => [...t, { id, message, variant }]);
    window.setTimeout(() => {
      setToasts((t) => t.filter((x) => x.id !== id));
    }, 4200);
  }, []);

  const api = useMemo(() => ({ showToast }), [showToast]);

  return (
    <Ctx.Provider value={api}>
      {children}
      <div className="vip-react-toast-host" aria-live="polite">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`vip-react-toast vip-react-toast--${t.variant || 'info'}`}
            role="status"
          >
            {t.message}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}

export function useToast(): ToastApi {
  const v = useContext(Ctx);
  if (!v) throw new Error('useToast must be used within ToastProvider');
  return v;
}
